export default __webpack_public_path__ + "static/media/Tango_For_Taj_(Music).f0d3abc5.mp3";